var $8977cb565542571b$exports = {};
$8977cb565542571b$exports = {
    "selectPlaceholder": `Select an item`,
    "tableResizer": `Resizer`,
    "dropzoneLabel": `DropZone`,
    "colorSwatchPicker": `Color swatches`
};


export {$8977cb565542571b$exports as default};
//# sourceMappingURL=en-US.mjs.map
